import React, { useEffect, useState } from 'react'

import Vertical from '../layouts/Vertical.jsx'
import Grid from '../components/Grid.jsx'
import Card from '../components/Card.jsx'
import Text from '../components/Text.jsx'
import useRect from '../hooks/useRect.js'
import usePosition from '../hooks/usePosition.js'

const Item = ({ value, getRect, width, y, fontSize }) => {
  const [ref, rect] = usePosition()

  useEffect(() => {
    if (typeof getRect === 'function') getRect(rect)
  }, [rect])

  return (
    <svg x={0} y={y} width={width} height={rect.height}>
      <circle cx={3} cy={(fontSize * 1.3) / 2 - 3} r="3" />
      <Text gRef={ref} value={value} width={width} x={17} y={0} fontSize={fontSize} />
    </svg>
  )
}

const Ul = ({ items, spacing = 0, fontSize = 24, getRect = () => {} }) => {
  const [rects, setRects] = useState([])
  const [Rect, rect] = useRect()

  useEffect(() => {
    getRect(rect)
  }, [rect])

  const getY = (index) => {
    const selectedRects = rects.slice(0, index)
    const y = selectedRects.reduce((y, rect) => y + rect.height + spacing, 0)
    return y
  }

  return (
    <svg x={'0'} y={'0'} width={'100%'} height={'100%'}>
      <Rect />
      {items.map((item, index) => (
        <Item
          key={index}
          value={item}
          getRect={(rect) => {
            setRects((rects) => {
              let newRects = [...rects]
              newRects[index] = rect
              return newRects
            })
          }}
          width={rect.width}
          y={getY(index)}
          fontSize={fontSize}
        />
      ))}
    </svg>
  )
}

// Audiences To Activate
const RecommendedSegments = (props) => {
  const { title, description, section_1, section_2, section_3 } = props.data

  const [Card1Rect, card1Rect] = useRect()
  const [Card2Rect, card2Rect] = useRect()

  const [header1Ref, header1Rect] = usePosition()
  const [header2Ref, header2Rect] = usePosition()
  const [header3Ref, header3Rect] = usePosition()
  const [header4Ref, header4Rect] = usePosition()

  return (
    <Vertical
      title={title}
      description={description}
      page={props.index + 1}
      content={() => (
        <Grid
          direction="horizontal"
          gap={48}
          items={[
            {
              component: (
                <Card showBorder={true}>
                  <Card1Rect />
                  <Grid
                    direction="vertical"
                    gap={32}
                    items={[
                      {
                        component: (
                          <>
                            <Text
                              gRef={header1Ref}
                              value={section_1.title}
                              width={card1Rect.width}
                              x={0}
                              y={0}
                              fontSize={32}
                              fontWeight={'bold'}
                              fill={'#A40965'}
                            />
                            <svg x={0} y={header1Rect.height + 16} width={'100%'} height={'100%'}>
                              {section_1.selected_entities && (
                                <Ul
                                  items={section_1.selected_entities.map((entity) => entity.name)}
                                />
                              )}
                            </svg>
                          </>
                        ),
                        size: 0.45,
                      },
                      {
                        component: (
                          <>
                            <Text
                              gRef={header2Ref}
                              value={section_2.title}
                              width={card1Rect.width}
                              x={0}
                              y={0}
                              fontSize={32}
                              fontWeight={'bold'}
                              fill={'#13682B'}
                            />
                            <svg x={0} y={header2Rect.height + 16} width={'100%'} height={'100%'}>
                              {section_2.selected_entities && (
                                <Ul
                                  items={section_2.selected_entities.map((entity) => entity.name)}
                                />
                              )}
                            </svg>
                          </>
                        ),
                        size: 0.55,
                      },
                    ]}
                  />
                </Card>
              ),
              size: 0.5,
            },
            {
              component: (
                <Card showBorder={true}>
                  <Card2Rect />
                  <Text
                    gRef={header3Ref}
                    value={section_3.title}
                    width={card2Rect.width}
                    x={0}
                    y={0}
                    fontSize={32}
                    fontWeight={'bold'}
                    fill={'#A40965'}
                  />
                  <Text
                    gRef={header4Ref}
                    value={section_3.note}
                    width={card2Rect.width}
                    x={0}
                    y={header3Rect.height + 16}
                    fontSize={24}
                    fill={'#666666'}
                  />
                  <svg
                    x={0}
                    y={header3Rect.height + 16 + header4Rect.height + 16}
                    width={'100%'}
                    height={'100%'}
                  >
                    <Ul
                      items={[
                        section_3?.signal_1,
                        section_3?.signal_2,
                        section_3?.signal_3,
                        section_3?.signal_4,
                        section_3?.signal_5,
                      ].filter(Boolean)}
                      spacing={16}
                    />
                  </svg>
                </Card>
              ),
              size: 0.5,
            },
          ]}
        />
      )}
    />
  )
}

export default RecommendedSegments
